"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groups = void 0;
const zod_1 = require("zod");
exports.groups = zod_1.z.object({
    groupIds: zod_1.z.array(zod_1.z.number()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        createdAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        groupId: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        contactsForGroup: zod_1.z
            .object({
            contactId: zod_1.z.literal(true).optional(),
            createdAt: zod_1.z.literal(true).optional(),
            email: zod_1.z.literal(true).optional(),
            language: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            sms: zod_1.z.literal(true).optional(),
            updatedAt: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute of the contacts',
        }),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the user if specifying any at all',
    }),
});
//# sourceMappingURL=groups.js.map